<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="showModal"
      width="600px"
      :close-on-click-modal="false"
      @close="cancel('addForm')"
    >
      <div style="width: 90%">
        <el-form
          ref="addForm"
          :model="form"
          :rules="rules"
          label-width="100px"
          size="small"
        >
          <el-form-item label="父级名称:" v-if="info">
            <el-input
              v-model="info.name"
              placeholder="请输入名称" maxlength="50"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="名称:" prop="name">
            <el-input v-model="form.name" placeholder="请输入名称" maxlength="50"></el-input>
          </el-form-item>
          <el-form-item label="显示顺序:" prop="showIndex">
            <el-input-number
              v-model="form.showIndex"
              :min="0"
              :max="999999999"
              label="请输入显示顺序"
              controls-position="right"
            ></el-input-number>
            <p class="u-tip">数字越小显示越靠前</p>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button @click="cancel('addForm')" size="small">取消</el-button>
        <el-button
          type="primary"
          @click="submitHandle('addForm')"
          :loading="btnloading"
          size="small"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "add-sub-modal",
  components: {},
  props: {
    title: {
      default: "新增",
      type: String,
    },
    show: {
      type: Boolean,
      default: false,
    },
    addShowIndex: {
      type: Number,
      default: 0,
    },
    info: {
      type: Object,
      default: function () {
        return {};
      },
    },
    editInfo: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      btnloading: false,
      showModal: false,
      form: {
        name: "",
        showIndex: 0,
      },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        showIndex: [
          { required: true, message: "显示顺序为必填项", trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      this.form.showIndex = this.addShowIndex;
      if (this.editInfo) {
        this.form.showIndex = this.editInfo.displayOrder;
        this.form.name = this.editInfo.name;
      }
      if (!val) this.$emit("close");
    },
  },
  computed: {
    ...mapGetters({
      user: "getUserInfo",
      group: "getGroup",
    }), 
  },
  methods: {
    ...mapActions({
        applicationrangePost: "hostSetModule/applicationrangePost",
      applicationrangePut: "hostSetModule/applicationrangePut",
    }),
    async submitHandle(name) {
      let valid = await this.validForm(name);
      if (!valid) return;
      this.btnloading = true;
      setTimeout(() => {
        this.btnloading = false;
      }, 5000); 
      let res = null;
      if (this.editInfo) {
        res = await this.editForm();
      } else {
        res = await this.addForm();
      }
      if (res) {
        this.$emit("finish");
        this.$notify({
          title: '成功',
          message: '操作成功！',
          type: 'success'
        });
        this.cancel();
      } else {
        this.$notify.error({
          title: '错误',
          message: '操作失败，请重新尝试'
        });
        this.btnloading = false;
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          resolve(valid);
        });
      });
    },
    cancel() {
      this.$refs["addForm"].resetFields();
      this.$emit("close");
      this.btnloading = false;
      this.showModal = false;
      this.form = {
        name: "",
        showIndex: 0,
      };
    },
    validField(name) {
      // 验证单个控件
      setTimeout((c) => {
        this.$refs.form.validateField(name);
      }, 400);
    },
    async addForm() {
      let opt = {
        name: this.form.name,
        displayOrder: this.form.showIndex,
        treeName:"",
        parentId: this.info.id,
      };
      let res = await this.applicationrangePost(opt);
      return Promise.resolve(res);
    },
    async editForm() {
      let opt = {
        id: this.editInfo.id,
        body: {
          name: this.form.name,
          displayOrder: this.form.showIndex,
          treeName:"",
          parentId:this.editInfo.parentId?this.editInfo.parentId:'',
        },
      };
      let res = await this.applicationrangePut(opt);
      return Promise.resolve(res);
    },
  },
  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped></style>
